import DashboardService from '@/modules/ta/dashboard/services/DashboardService';

// TA-50995: regenerate a dashboard thumbnail once editing settles instead of on every change.
export const DASHBOARD_THUMBNAIL_DEBOUNCE_MS = 30000;

const pendingTimers = new Map();
let isPageHideListenerRegistered = false;

function requestThumbnail(dashboardId, options) {
  DashboardService.updateThumbnail(dashboardId, options).catch(() => {});
}

function flush({ keepalive = false } = {}) {
  pendingTimers.forEach((timer, dashboardId) => {
    clearTimeout(timer);
    requestThumbnail(dashboardId, { keepalive });
  });
  pendingTimers.clear();
}

function registerPageHideFlush() {
  if (isPageHideListenerRegistered) return;
  // keepalive lets the request outlive the page when the tab is closed or reloaded.
  window.addEventListener('pagehide', () => flush({ keepalive: true }));
  isPageHideListenerRegistered = true;
}

export const DashboardThumbnailScheduler = {
  schedule(dashboardId) {
    registerPageHideFlush();
    clearTimeout(pendingTimers.get(dashboardId));
    pendingTimers.set(
      dashboardId,
      setTimeout(() => {
        pendingTimers.delete(dashboardId);
        requestThumbnail(dashboardId);
      }, DASHBOARD_THUMBNAIL_DEBOUNCE_MS)
    );
  },
  flush,
  hasPending(dashboardId) {
    return pendingTimers.has(dashboardId);
  },
};
